export {default as CallbackRoute} from './CallbackRoute';



// WEBPACK FOOTER //
// ./src/components/CallbackRoute/index.tsx